import * as React from "react";
import { forwardRef } from "react";
const BankTransferIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 48 48",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fill: "#A58EE7",
  fillRule: "evenodd",
  d: "M9.60937 19.5834c-1.18821.9417-.52233 2.854.99383 2.854h1.4134v14.8967c0 .1756.0141.3478.0413.5156h-1.389c-.74131 0-1.34224.601-1.34224 1.3422 0 .7413.60093 1.3423 1.34224 1.3423h26.9039c.7413 0 1.3423-.601 1.3423-1.3423 0-.7412-.601-1.3422-1.3423-1.3422H36.184c.0272-.1678.0413-.34.0413-.5156V22.4374h1.9025c1.4924 0 2.1721-1.8626 1.0306-2.8239L25.8131 8.37611c-.5819-.48995-1.4282-.50252-2.0244-.03006zm9.13203 3.5019h-2.6899v14.7644h2.6899zm4.0346 0h2.6899v14.7644H22.776zm9.4145 0h-2.6898v14.7644h2.6898z",
  clipRule: "evenodd"
}));
const ForwardRef = forwardRef(BankTransferIcon);
export { ForwardRef as BankTransferIcon };